import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import Home from "./Pages/Home";
import Success from "./Pages/Success";
import "./App.css";
import PincodeFinder from "./Pages/Pincode";

function App() {
  return (
    <BrowserRouter>
      <div className="app-shell">
        <Header />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/success" element={<Success />} />
            <Route
              path="/warranty-terms-and-conditions"
              element={<Success />}
            />
            <Route
              path="/extended-warranty-terms-and-conditions"
              element={<Success />}
            />
            <Route path="/privacy-policy" element={<Success />} />
            <Route path="/pin-code" element={<PincodeFinder />} />
          </Routes>
        </main>
        <Footer />
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  );
}

export default App;
